import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { rcsbaseurl } from "../../Appjs/api.js";
import { encryptPayload } from "../../utility/secureLogin.js";

const rawRcsBaseQuery = fetchBaseQuery({
  baseUrl: rcsbaseurl,
  credentials: "include",
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("accessToken");

    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    return headers;
  },
});

const splitUrlAndQuery = (url = "") => {
  const [path, queryString] = String(url).split("?");

  const params = {};

  if (queryString) {
    const searchParams = new URLSearchParams(queryString);

    searchParams.forEach((value, key) => {
      params[key] = value;
    });
  }

  return { path, params };
};

const convertFormDataToSecureFormData = (formData, meta) => {
  const secureFormData = new FormData();

  const fields = {};
  const fileMap = [];

  formData.forEach((value, key) => {
    if (value instanceof File) {
      fileMap.push({
        originalFieldName: key,
        fileName: value.name,
      });

      secureFormData.append("files", value, "upload.bin");
    } else {
      if (fields[key]) {
        if (Array.isArray(fields[key])) {
          fields[key].push(value);
        } else {
          fields[key] = [fields[key], value];
        }
      } else {
        fields[key] = value;
      }
    }
  });

  secureFormData.append(
    "data",
    encryptPayload({
      ...meta,
      fields,
      fileMap,
    }),
  );

  return secureFormData;
};

export const secureRcsBaseQuery = async (args, apiData, extraOptions) => {
  const originalArgs = typeof args === "string" ? { url: args } : { ...args };

  const method = originalArgs.method?.toUpperCase() || "GET";

  const { path, params: urlParams } = splitUrlAndQuery(originalArgs.url);

  const finalParams = {
    ...urlParams,
    ...(originalArgs.params || {}),
  };

  const isFormData = originalArgs.body instanceof FormData;

  // RCS file upload bhi /secure/request par jayega
  if (isFormData) {
    const secureFormData = convertFormDataToSecureFormData(originalArgs.body, {
      url: path,
      method,
      params: finalParams,
      isUpload: true,
    });

    return rawRcsBaseQuery(
      {
        ...originalArgs,
        url: "/secure/request",
        method: "POST",
        params: undefined,
        body: secureFormData,
        headers: undefined,
      },
      apiData,
      extraOptions,
    );
  }

  // RCS normal JSON + GET APIs
  return rawRcsBaseQuery(
    {
      ...originalArgs,
      url: "/secure/request",
      method: "POST",
      params: undefined,
      body: {
        data: encryptPayload({
          url: path,
          method,
          body: originalArgs.body || {},
          params: finalParams,
          isUpload: false,
        }),
      },
    },
    apiData,
    extraOptions,
  );
};
